import { render, staticRenderFns } from "./UserBlock.vue?vue&type=template&id=65b4d6c4"
import script from "./UserBlock.vue?vue&type=script&lang=js"
export * from "./UserBlock.vue?vue&type=script&lang=js"
import style0 from "./UserBlock.vue?vue&type=style&index=0&id=65b4d6c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports